export default __webpack_public_path__ + "static/media/sumo.098147e3.png";